import { getFieldSetFieldListDataForFieldSet } from '../fieldSetFields/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IFieldSet, IFieldSetOverview } from '~/types/fieldSet/models'
import {
  getFieldSetTypeById,
  FieldSetTypeIds,
} from '~/services/selectLists/fieldSetTypes'

const fieldSetListData = undefined as unknown as IFieldSet[]

export const getFieldSetListData = getListDataFunctionFactory<IFieldSet[]>({
  listData: fieldSetListData,
  storageKey: 'fieldsets',
  getStartingListData: getStartingFieldSetListData,
  forOfFunction: async (fs) => {
    const fieldSetFields = await getFieldSetFieldListDataForFieldSet(fs.id)
    if (fieldSetFields) {
      fs.numFields = fieldSetFields.length
    }
  },
})

export async function getFieldSetData(id: string) {
  const listData: IFieldSet[] = await getFieldSetListData()
  return listData.find((fieldSet) => fieldSet.id === id)
}

export async function getFieldSetOverviewData(
  id: string
): Promise<IFieldSetOverview> {
  const fieldSet = await getFieldSetData(id)
  if (!fieldSet) {
    throw new Error('fieldSet is falsey')
  }
  const fieldSetFields = (await getFieldSetFieldListDataForFieldSet(id)) ?? []
  return { fieldSet, fields: fieldSetFields }
}

export async function getStartingFieldSetListData(): Promise<IFieldSet[]> {
  return [
    {
      id: 'XXFS0002',
      hrid: 'FS0002',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'DIA',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0003',
      hrid: 'FS0003',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'SDWAN',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0004',
      hrid: 'FS0004',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'IP List',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0005',
      hrid: 'FS0005',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'Network Base',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0006',
      hrid: 'FS0006',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'UCaaS',
      createdAt: '2023-12-01T18:18:00.000Z',
      modifiedAt: '2023-12-01T18:18:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0007',
      hrid: 'FS0007',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'SDWAN Device',
      createdAt: '2023-12-03T23:34:00.000Z',
      modifiedAt: '2023-12-03T23:34:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0008',
      hrid: 'FS0008',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'Toll Free Numbers',
      createdAt: '2024-03-03T00:51:00.000Z',
      modifiedAt: '2024-03-03T00:51:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0009',
      hrid: 'FS0009',
      type: getFieldSetTypeById(FieldSetTypeIds.ORDER_DETAILS),
      descr: 'Circuit',
      createdAt: '2025-03-23T00:51:00.000Z',
      modifiedAt: '2025-03-23T00:51:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXFS0010',
      hrid: 'FS0010',
      type: getFieldSetTypeById(FieldSetTypeIds.SPEC),
      descr: 'POTS Line',
      createdAt: '2025-04-23T00:51:00.000Z',
      modifiedAt: '2025-04-23T00:51:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
  ]
}
